import { Button } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import { StyledComponentProps, StyleRules, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import * as React from 'react';
import { Component } from 'react';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import App from '../../models/App';
import GroupApp from '../../models/GroupApp';

interface Props {
  appId?: string | number;
  cToken?: string;
  app?: App;
  groupApp?: GroupApp;
  history?: any;
  appListSize?: number;
  clearSkipToApp?: () => void;
}

interface RouterProps {
  navigate: (path: string) => void;
}
const styles: StyleRules = {
  pageContent: {
    backgroundColor: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: 'column',
  },
  cardContent: {
    padding: '0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: 'column',
    width: 'fit-content',
  },
};

class CustomerFlowUpdateInProgress extends Component<Props & StyledComponentProps & RouterProps> {
  constructor(props) {
    super(props);
    this.returnToApplicationList = this.returnToApplicationList.bind(this);
  }

  public render() {
    const classes = this.props.classes!;
    return (
      <Card className={classes.pageContent} style={{ padding: '24px', marginTop: '32px' }}>
        <CardHeader title={<Trans i18nKey="lockedApplication.updateIsInProgressTitle" />} component="h1" />
        <CardContent className={classes.cardContent}>
          <Typography><Trans i18nKey="lockedApplication.updateIsInProgressBody" /></Typography>
        </CardContent>
        {this.shouldHideBackToApplicationListButton() ? null : this.returnToListButton()}
      </Card>
    );
  }

  private returnToListButton() {
    return (
      <Button variant="contained" type="submit" onClick={this.returnToApplicationList}>
        <ChevronLeft />
        <Trans>Return_to_Application_List</Trans>
      </Button>
    );
  }

  private returnToApplicationList() {
    this.props.clearSkipToApp?.();
    if (typeof this.props.navigate === 'function') {
      this.props.navigate('/applist');
    }
  }

  private shouldHideBackToApplicationListButton() {
    return (this.props.appListSize && this.props.appListSize === 1);
  }
}

function CustomerFlowUpdateInProgressWithRouter(props: Props & StyledComponentProps) {
  const navigate = useNavigate();
  return <CustomerFlowUpdateInProgress {...props} navigate={navigate} />;
}

export default withStyles(styles)(CustomerFlowUpdateInProgressWithRouter);
